/* eslint-disable */

/** unique or primary key constraints on table "argo.sn" */
export enum ArgoSnConstraint {
  /** unique or primary key constraint on columns "context_id", "content" */
  SnGlobalUniq = 'sn_global_uniq',
  /** unique or primary key constraint on columns "context_id", "sn_id" */
  SnPkey = 'sn_pkey',
  /** unique or primary key constraint on columns "context_id", "sn_format_id", "content" */
  SnUniq = 'sn_uniq'
}

/** select columns of table "argo.sn" */
export enum ArgoSnSelectColumn {
  /** column name */
  Content = 'content',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  SnSeqId = 'sn_seq_id',
  /** column name */
  Unq = 'unq'
}

/** update columns of table "argo.sn" */
export enum ArgoSnUpdateColumn {
  /** column name */
  Content = 'content',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  SnFormatId = 'sn_format_id',
  /** column name */
  SnSeqId = 'sn_seq_id',
  /** column name */
  Unq = 'unq'
}

